import React from "react";
import "../css/Footer.css";
import { FaInstagram, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer sticky-footer">
      <div className="footer-content">

        <div className="footer-logo">
          <h2>© {new Date().getFullYear()} Prosetwin</h2>
        </div>

        <div className="footer-contact">
          <a href="tel:+905388552260" className="contact-item">
            <FaPhoneAlt className="icon" /> +90 (538) 855 22 60
          </a>
          <a href="mailto:prosetwin@gmail.com" className="contact-item">
            <FaEnvelope className="icon" /> prosetwin@gmail.com
          </a>
        </div>

        <div className="footer-social">
          <a
            href="https://www.instagram.com/prosetwin"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <FaInstagram className="icon" />
          </a>
        </div>
      </div>
      <div className="footer-glow"></div>
    </footer>
  );
};

export default Footer;
